// modules/gsap-utils.js
import { ScrollSettle } from './scroll-settler';

export function settledTrigger({ trigger, start='top 80%', once=true }, tl, waitMs=220) {
    tl.pause(0);
    let off = null, to = null;
    const arm = () => {
        clearTimeout(to);
        to = setTimeout(() => { off?.(); off = null; tl.play(); }, waitMs);
    };
    const st = ScrollTrigger.create({
        trigger, start, once,
        onEnter: () => { off?.(); off = ScrollSettle.on(arm); ScrollSettle.ping(); },
        onLeave: () => { clearTimeout(to); tl.pause(); },
        onEnterBack: () => { off?.(); off = ScrollSettle.on(arm); ScrollSettle.ping(); },
        onLeaveBack: () => { clearTimeout(to); tl.pause(); },
    });
    return st;
}
